/**
 * Extracted from sections/fa-main-product.liquid (inline <script> blocks at lines 940, 982, 1004, 1124).
 * Moved verbatim into a cacheable, deferred asset so the browser can cache it
 * across page loads and stop parsing/compiling it during the HTML parse.
 * Found while fixing INP on the PDP (inline JS was the largest first-party
 * main-thread cost). Logic intentionally unchanged.
 */

// --- original inline block #1 (was at sections/fa-main-product.liquid:940) ---
(function () {
  document.addEventListener("DOMContentLoaded", function() {
 
    document.querySelectorAll('.upgrade-container-info-title, .upgrade-container-img').forEach(function(el) {
        el.addEventListener('click', function(e) {
          // If you clicked directly on the button, do nothing
          if (e.target.closest('.upgrade-container-popup-btn')) {
            return;
          }
          const btn = el.parentNode.querySelector('.upgrade-container-popup-btn');
          if (btn) {
            btn.click();
          }
        });
      }); 
    });


  document.addEventListener('scroll', function(event) {
    // get the top position of specific element
    function getTopPositionRelativeToDocument(element) {
      const rect = element.getBoundingClientRect();
      const scrollTop = window.scrollY; // or use window.pageYOffset for older browsers
      return rect.top + scrollTop;
    }
    const productLeft = document.querySelector('.pdp-product-left');
    // Graceful sticky for ALL PDPs (reviews or not): the .pdp-product-left column is a
    // <safe-sticky> with CSS position:sticky (>=1000px), so the theme's safe-sticky engine
    // drives graceful scroll-then-pin for the column as one unit (gallery, or gallery+reviews).
    // No JS follow-margin is used in any layout — clear any stale inline margin-top that an
    // earlier code path may have left on the column or the gallery, then bail. Below 1000px
    // the column is not sticky and stacks/scrolls naturally (still no follow-margin).
    if (productLeft && productLeft.style.marginTop) { productLeft.style.marginTop = ''; }
    const gallery = document.querySelector('.product-gallery');
    if (gallery && gallery.style.marginTop) { gallery.style.marginTop = ''; }
    return;
  });
})();

// --- original inline block #2 (was at sections/fa-main-product.liquid:982) ---
(function () {
  document.addEventListener('DOMContentLoaded', () => {
    const fixGridItems = () => {
      const items = document.querySelectorAll('.jm-expanded-media-grid__item[role="listitem"]');
      items.forEach(btn => {
        if (btn.parentElement.tagName === 'LI') return;

        const li = document.createElement('li');
        li.style.cssText = 'list-style:none;margin:0;padding:0;display:contents;';
        btn.parentNode.insertBefore(li, btn);
        li.appendChild(btn);
        btn.removeAttribute('role');
      });
    };

    fixGridItems();

    const observer = new MutationObserver(fixGridItems);
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();

// --- original inline block #3 (was at sections/fa-main-product.liquid:1004) ---
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector(".new_upsell_container")){
        let ATCButton = document.querySelector(".product-info__buy-buttons").querySelector('button[type="submit"]');
        ATCButton.addEventListener("click", (event) => {
        event.preventDefault();
        handleATCForNewUpsell();
      })
      document.querySelectorAll("product-quick-add").forEach((el) => {
        el.querySelectorAll("buy-buttons").forEach((innerEl) => {
          innerEl.addEventListener("click", (event) => {
            event.preventDefault();
            innerEl.querySelector("button").classList.add("loading");
            handleATCForNewUpsell()
          })
        })
      })
    }
  })
  function setButtonToLoadingState(btn) {
    btn.firstElementChild.setAttribute("style", 'transform: translateY(20px);opacity: 0;');
    btn.children[1].setAttribute("style", 'transform: none;opacity: 1;');
  }
  function unsetButtonToLoadingState(btn) {
    btn.firstElementChild.setAttribute("style", 'transform: translateY(0px);opacity: 1;');
    btn.children[1].setAttribute("style", 'transform: translateY(20px);opacity: 0;');
    document.querySelectorAll("buy-buttons").forEach((el)=>{
      el.querySelectorAll("button").forEach((innerEl)=>{
        innerEl.classList.remove("loading")
      })
    })
  }
  function handleATCForNewUpsell() {
    let atcButton = document.querySelector(".product-info__buy-buttons").querySelector('button[type="submit"]');
    setButtonToLoadingState(atcButton);
    let productsToAddBundle = [];
    let sectionsToBundle = ["variant-added"];
    productsToAddBundle.push({
      id: document.querySelector(".new_upsell_pa-container").getAttribute("data-main-product-id"),
      quantity: 1
    })
    if (document.querySelector(".pa-container-info.active")) {
      productsToAddBundle.push({
        id: document.querySelector(".new_upsell_pa-container").getAttribute("data-product-id"),
        quantity: 1
      })
    }
    document.querySelectorAll(".upgrade-container.swiper-slide.active").forEach((el) => {
      productsToAddBundle.push({
        id: el.getAttribute("data-product-id"),
        quantity: 1
      })
    })
    if (productsToAddBundle.length) {
      window
        .nsCartAdd({ items: productsToAddBundle, sections: sectionsToBundle })
        .then(function () {
          if (atcButton.parentElement.getAttribute("data-direct-checkout") == "true") {
            window.location.href = "/checkout";
            return;
          }
          unsetButtonToLoadingState(atcButton);
        })
        .catch(function (error) {
          // The button was put into its loading state before the request; leaving
          // it there on a failure is what made a sold-out add look like a hang.
          console.error("[fa-main-product] add to cart failed:", error);
          unsetButtonToLoadingState(atcButton);
        });
    }
  }
})();

// --- original inline block #4 (was at sections/fa-main-product.liquid:1124) ---
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const allUpgradesCheckboxes = document.querySelectorAll(".upgrade-container-info-toggle-check");
    const popularAddonCheckbox = document.querySelector("#PopularAddonCheckbox");

    function calculateTotalSelectedInputs() {
      let activeSlidesLength = document.querySelectorAll(".upgrade-container.swiper-slide.active").length;
      activeSlidesLength += popularAddonCheckbox?.checked ? 1 : 0;

      document.querySelectorAll(".popular-addon-quantity").forEach((el) => {
        el.innerHTML = activeSlidesLength > 0 ? `(+${activeSlidesLength})` : ``;
      });
    }

    allUpgradesCheckboxes.forEach((el) => {
      el.addEventListener("input", calculateTotalSelectedInputs);
    });

    if (popularAddonCheckbox) {
      popularAddonCheckbox.addEventListener("input", calculateTotalSelectedInputs);
    }

    calculateTotalSelectedInputs();
  });
})();
